export default __webpack_public_path__ + "static/media/invitation-bg2.28708385.png";